import { isEmpty, isNil, map, size } from 'lodash'

import getDataUrlFromBlob from './get-data-url-from-blob'

const convertFileListToDataUrls = async fileList => {
  if (isEmpty(fileList)) {
    return []
  }

  return Promise.all(
    map(fileList, async file => {
      if (isNil(file.originFileObj)) {
        const extension = file.url.slice(size(file.url) - 4, size(file.url))
        const isSvg = extension === '.svg'
        if (!isSvg) {
          return file.url
        }

        const imageUrl = await getDataUrlFromBlob(file.url, isSvg)
        return imageUrl
      }

      const imageUrl = await getDataUrlFromBlob(file.originFileObj, false)
      return imageUrl
    }),
  )
}

export default convertFileListToDataUrls
